module.exports = __webpack_public_path__ + "img/4.a1a357d1.jpg";